module.exports = __webpack_public_path__ + "img/seat.125e60a5.png";